

import { computed, ref } from 'vue'
import moment from 'moment';
import {FilterMatchMode, FilterOperator} from "primevue/api";
import router from "@/router";
import {useToast} from "primevue/usetoast";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import { useConfirm } from "primevue/useconfirm";
import {BaoCaoCoSoLaoDong} from "@/models/baoCaoCoSoLaoDong";
import {ThongTinLaoDong} from "@/models/thongTinLaoDong";
import CDCRepository from "@/services/CDCRepository";
import {BaoCaoYTeLaoDongTuyenHuyen} from "@/models/baoCaoYTeLaoDongTuyenHuyen";
import {TongSoMau} from "@/models/tongSoMau";


export default {
  setup() {
    const confirm = useConfirm();
    const toast = useToast();
    const store = useStore();
    const date = ref();
    const service = ref("");
    const router = useRouter();
    const baoCao = ref({} as BaoCaoYTeLaoDongTuyenHuyen);
    console.log("####################@@@@@@@@@@@@@@@@@@@@@ baoCaoCoSoLaoDong aaaa: ");
    const initDb = () => {
      baoCao.value.coSoLaoDongTrongPVQLs = [
        {loaiCSLD: "Trên 200 NLĐ"},
        {loaiCSLD: "100-200 NLĐ"},
        {loaiCSLD: "Dưới 100 NLĐ"},
      ];
      baoCao.value.phanLoaiCoSoLaoDongTheoNghes = [
        {loaiNganhNghe: "Nông nghiệp"},
        {loaiNganhNghe: "Lâm nghiệp"},
        {loaiNganhNghe: "Thủy sản"},
        {loaiNganhNghe: "Khai thác mỏ"},
        {loaiNganhNghe: "Công nghiệp chế biến, chế tạo"},
        {loaiNganhNghe: "Sản xuất và phân phối năng lượng"},
        {loaiNganhNghe: "Cung cấp nước, QL, xử lý rác/nước thải"},
        {loaiNganhNghe: "Xây dựng"},
        {loaiNganhNghe: "Thương nghiệp, dịch vụ sửa chữa"},
        {loaiNganhNghe: "Vận tải, kho bãi"},
        {loaiNganhNghe: "Khách sạn nhà hàng"},
        {loaiNganhNghe: "Thông tin, truyền thông"},
        {loaiNganhNghe: "Tài chính, tín dụng và bảo hiểm"},
        {loaiNganhNghe: "Kinh doanh bất động sản"},
        {loaiNganhNghe: "Hoạt động chuyên môn, KHCN"},
        {loaiNganhNghe: "Hoạt động hành chính và dịch vụ hỗ trợ"},
        {loaiNganhNghe: "Quản lý nhà nước, an ninh q/phòng"},
        {loaiNganhNghe: "Giáo dục và đào tạo"},
        {loaiNganhNghe: "Y tế và các hoạt động cứu trợ XH"},
        {loaiNganhNghe: "Hoạt động văn hóa xã hội"},
        {loaiNganhNghe: "Các hoạt động dịch vụ khác"},
        {loaiNganhNghe: "Làm thuê các công việc tại hộ gia đình"},
        {loaiNganhNghe: "Hoạt động các tổ chức, cơ quan quốc tế"},
      ]
      baoCao.value.phanLoaiCoSoLaoDongNguyHais = [
        {loaiNganhNghe: "Nông nghiệp"},
        {loaiNganhNghe: "Lâm nghiệp"},
        {loaiNganhNghe: "Thủy sản"},
        {loaiNganhNghe: "Khai thác mỏ"},
        {loaiNganhNghe: "Công nghiệp chế biến, chế tạo"},
        {loaiNganhNghe: "Sản xuất và phân phối năng lượng"},
        {loaiNganhNghe: "Cung cấp nước, QL, xử lý rác/nước thải"},
        {loaiNganhNghe: "Xây dựng"},
        {loaiNganhNghe: "Thương nghiệp, dịch vụ sửa chữa"},
        {loaiNganhNghe: "Vận tải, kho bãi"},
        {loaiNganhNghe: "Khách sạn nhà hàng"},
        {loaiNganhNghe: "Thông tin, truyền thông"},
        {loaiNganhNghe: "Tài chính, tín dụng và bảo hiểm"},
        {loaiNganhNghe: "Kinh doanh bất động sản"},
        {loaiNganhNghe: "Hoạt động chuyên môn, KHCN"},
        {loaiNganhNghe: "Hoạt động hành chính và dịch vụ hỗ trợ"},
        {loaiNganhNghe: "Quản lý nhà nước, an ninh q/phòng"},
        {loaiNganhNghe: "Giáo dục và đào tạo"},
        {loaiNganhNghe: "Y tế và các hoạt động cứu trợ XH"},
        {loaiNganhNghe: "Hoạt động văn hóa xã hội"},
        {loaiNganhNghe: "Các hoạt động dịch vụ khác"},
        {loaiNganhNghe: "Làm thuê các công việc tại hộ gia đình"},
        {loaiNganhNghe: "Hoạt động các tổ chức, cơ quan quốc tế"},
      ]
      baoCao.value.hoSoVeSinhLaoDongs= [{tongSoCSQL: 0, soCSLapHSQL: 0, tongSoCSNH: 0, soCSLapHSNH: 0}];
      baoCao.value.toChucBoPhanYTeTaiCSLDs= [
          {loaiCSSX: "Trên 200 NLĐ"},
          {loaiCSSX: "100-200 NLĐ"},
          {loaiCSSX: "Dưới 100NLĐ"},
      ];
      baoCao.value.trinhDoNguoiLamCongTacYTes= [
          {loaiCSSX: "Trên 200 NLĐ"},
          {loaiCSSX: "100-200 NLĐ"},
          {loaiCSSX: "Dưới 100NLĐ"},
      ];
      baoCao.value.lucLuongSoCuus= [
          {loaiCSSX: "Trên 200 NLĐ"},
          {loaiCSSX: "100-200 NLĐ"},
          {loaiCSSX: "Dưới 100NLĐ"},
      ];
      baoCao.value.ketQuaQuanTracViKhiHaus= [
          {tenCoSo: "", nhietDo: {},doAm: {},tocDoGio: {},anhSang: {},on: {},rung: {},hKDoc: {},phongXa: {},dienTuTruong: {},yeuToKhac: {},},
          {tenCoSo: "", nhietDo: {},doAm: {},tocDoGio: {},anhSang: {},on: {},rung: {},hKDoc: {},phongXa: {},dienTuTruong: {},yeuToKhac: {},},
      ];
      baoCao.value.ketQuaQuanTracYeuToBuis= [
        {tenCoSo: "", buiToanPhan: {},buiHoHap: {},buiSilic: {},buiKhac: {},tongSo: {}},
        {tenCoSo: "", buiToanPhan: {},buiHoHap: {},buiSilic: {},buiKhac: {},tongSo: {}},
      ];
      baoCao.value.tinhHinhSucKhoes= [
        {tenCoSo: "", om: {},taiNanLaoDong: {},benhNgheNghiep: {},tongSo: {}},
        {tenCoSo: "", om: {},taiNanLaoDong: {},benhNgheNghiep: {},tongSo: {}},
      ];
      baoCao.value.soCoSoBaoCaos= [
        {nhomBenh: "Lao phổi (A15-A19)", sauThangDauNam: {}, sauThangCuoiNam: {}},
        {nhomBenh: "Ung thư phổi (C34)", sauThangDauNam: {}, sauThangCuoiNam: {}},
        {nhomBenh: "Viêm xoang, mũi họng, thanh quản cấp (J00-J06)", sauThangDauNam: {}, sauThangCuoiNam: {}},
        {nhomBenh: "Viêm xoang, mũi họng, thanh quản mạn (J31-J37)", sauThangDauNam: {}, sauThangCuoiNam: {}},
        {nhomBenh: "Viêm phế quản cấp (J05)", sauThangDauNam: {}, sauThangCuoiNam: {}},
        {nhomBenh: "Viêm phế quản mạn (J41-J42)", sauThangDauNam: {}, sauThangCuoiNam: {}},
        {nhomBenh: "Viêm phổi (J09-J18)", sauThangDauNam: {}, sauThangCuoiNam: {}},
        {nhomBenh: "Hen phế quản, giãn phế quản, dị ứng (J45-J47)", sauThangDauNam: {}, sauThangCuoiNam: {}},
        {nhomBenh: "Ỉa chảy, viêm dạ dày, ruột do NT (A00-A09)", sauThangDauNam: {}, sauThangCuoiNam: {}},
        {nhomBenh: "Bệnh nội tiết (E15-E16, E20-E35)", sauThangDauNam: {}, sauThangCuoiNam: {}},
        {nhomBenh: "Bệnh tâm thần (F00-F28)", sauThangDauNam: {}, sauThangCuoiNam: {}},
        {nhomBenh: "Bệnh thần kinh tr/ương và ngoại biên (G60-G64)", sauThangDauNam: {}, sauThangCuoiNam: {}},
        {nhomBenh: "Bệnh mắt (H53-H54)", sauThangDauNam: {}, sauThangCuoiNam: {}},
        {nhomBenh: "Bệnh tai (H60-H62, H65-H75, H80-H83, H90-H95)", sauThangDauNam: {}, sauThangCuoiNam: {}},
        {nhomBenh: "Bệnh tim mạch (I05-I15, I20-I25, I30-I52)", sauThangDauNam: {}, sauThangCuoiNam: {}},
        {nhomBenh: "Bệnh dạ dày, tá tràng (K20-K31)", sauThangDauNam: {}, sauThangCuoiNam: {}},
        {nhomBenh: "Bệnh gan, mật (K70-K77, K80-K87)", sauThangDauNam: {}, sauThangCuoiNam: {}},
        {nhomBenh: "Bệnh thận, tiết niệu (N00-N08, N10-N19, N25- N29)", sauThangDauNam: {}, sauThangCuoiNam: {}},
        {nhomBenh: "Bệnh phụ khoa/số nữ (N94.9)", sauThangDauNam: {}, sauThangCuoiNam: {}},
        {nhomBenh: "Sảy thai/số nữ có thai (O02-O03)", sauThangDauNam: {}, sauThangCuoiNam: {}},
        {nhomBenh: "Bệnh da (L00-L99)", sauThangDauNam: {}, sauThangCuoiNam: {}},
        {nhomBenh: "Bệnh cơ, xương khớp (M60-M99)", sauThangDauNam: {}, sauThangCuoiNam: {}},
        {nhomBenh: "Bệnh sốt rét (B50, B53)", sauThangDauNam: {}, sauThangCuoiNam: {}},
        {nhomBenh: "Các loại bệnh khác (Ghi rõ cụ thể)", sauThangDauNam: {}, sauThangCuoiNam: {}},
      ];
      baoCao.value.truongHopMacBenhNgheNghiep= [
        {nhomBenh: "Bệnh nghề nghiệp", sauThangDauNam: {}, sauThangCuoiNam: {}},
      ];
      baoCao.value.truongTaiNanLaoDong= [
        {nhomBenh: "Tai nạn lao động", sauThangDauNam: {}, sauThangCuoiNam: {}},
      ];
      baoCao.value.danhGiaCacYeuTos= [
        {tenCoSo: "",},
        {tenCoSo: "",},
      ];
      baoCao.value.phanLoaiSucKhoes= [
        {soNguoiDuocKSK: "Nam",},
        {soNguoiDuocKSK: "Tỷ lệ %",},
        {soNguoiDuocKSK: "Nữ",},
        {soNguoiDuocKSK: "Tỷ lệ %",},
        {soNguoiDuocKSK: "Tổng cộng",},
        {soNguoiDuocKSK: "Tỷ lệ %",},
      ];
      baoCao.value.ketQuaKhamPhatHienBenhs= [
        {tenBenh: "Bệnh bụi phổi silic nghề nghiệp;", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh bụi phổi amiăng nghề nghiệp;", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh bụi phổi bông nghề nghiệp;", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh bụi phổi talc nghề nghiệp;", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh bụi phổi than nghề nghiệp;", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh viêm phế quảnmạn tính nghề nghiệp;", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh hen phế quản nghề nghiệp;", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh nhiễm độc chì nghề nghiệp", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh nhiễm độc nghề nghiệp do benzen và đồng đẳng", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh nhiễm độc thủy ngân nghề nghiệp", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh nhiễm độc mangan nghề nghiệp;", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh nhiễm độc trinitrotoluen nghề nghiệp", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh nhiễm độc asen nghề nghiệp", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh nhiễm độc hóa chất bảo vệ thực vật nghề nghiệp (nhóm phốt pho hữu cơ và cacbamat)", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh nhiễm độc nicotin nghề nghiệp", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh nhiễm độc monoxit cacbon nghề nghiệp", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh nhiễm độc cadimi nghề nghiệp", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh điếc nghề nghiệp do tiếng ồn;", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh tăng hoặc giảm áp nghề nghiệp;", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh nghề nghiệp do rung toàn thân;", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh nghề nghiệp do rung cục bộ;", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh phóng xạ nghề nghiệp;", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh đục thủy tinh thể nghề nghiệp;", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh nốt dầu nghề nghiệp;", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh sạm da nghề nghiệp", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh viêm da tiếp xúc nghề nghiệp do crôm;", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh da nghề nghiệp do tiếp xúc môi trường ẩm ướt và lạnh kéo dài;", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh da nghề nghiệp do tiếp xúc với cao su tự nhiên và hóa chất;", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh xoắn khuẩn Leptospira nghề nghiệp;", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh viêm gan virut nghề nghiệp;", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh lao nghề nghiệp;", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh nhiễm HIV do tai nạn rủi ro nghề nghiệp;", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh viêm gan vi rút C nghề nghiệp;", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh ung thư trung biểu mô nghề nghiệp", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
        {tenBenh: "Bệnh Covid-19", phatBenhKhiKham: {}, duocChanDoanBenh: {}, duocGiamDinh: {}, ketQuaDuoi5: {}, ketQuaTu5Den30: {}, ketQuaTren31: {}},
      ];
      baoCao.value.danhSachMacBNNs= [
        {hoTenBenhNhan: "",},
        {hoTenBenhNhan: "",},
      ]
      baoCao.value.huanLuyenVeYTLDs= [
        {noiDung: "Huấn luyện về sơ cấp cứu cho người lao động",},
        {noiDung: "Huấn luyện về an toàn lao động",},
        {noiDung: "Huấn luyện SCCC cho lực lượng SCCC",},
        {noiDung: "Các nội dung huấn luyện khác (Ghi cụ thể)",},
        {noiDung: "Huấn luyện chuyên môn kỹ thuật về vệ sinh lao động",},
        {noiDung: "Huấn luyện chuyên môn về quản lý sức khỏe người lao động, phòng chống bệnh nghề nghiệp",},
        {noiDung: "Huấn luyện chuyên môn kỹ thuật về sơ cứu, cấp cứu",},
        {noiDung: "Huấn luyện nâng cao sức khỏe nơi làm việc, dinh dưỡng, ATVSTP, phòng chống dịch tại nơi làm việc",},
        {noiDung: "Huấn luyện các nội dung khác (Ghi cụ thể)",},
      ]

    }
    initDb();

    // const addThongTin = () => {
    //   coSoLaoDongTrongPVQLs.value.thongTinLaoDongs.push({hoVaTen:""});
    // }
    //

    const totalCSLD = (id) => {
      let total = 0;
      if(id == 1) {
        for (let a of baoCao.value.coSoLaoDongTrongPVQLs) {
          if (a.tongSo != null)
            total += a.tongSo;
        }
      }
      else if(id == 2){
        for (let a of baoCao.value.coSoLaoDongTrongPVQLs) {
          if (a.soTrucThuoc != null)
            total += a.soTrucThuoc;
        }
      }
      else if(id == 3){
        for (let a of baoCao.value.coSoLaoDongTrongPVQLs) {
          if (a.soCSCoYeuToCoHai != null)
            total += a.soCSCoYeuToCoHai;
        }
      }
      else if(id == 4){
        for (let a of baoCao.value.coSoLaoDongTrongPVQLs) {
          if (a.tongSoCoSo != null)
            total += a.tongSoCoSo;
        }
      }
      else if(id == 5){
        for (let a of baoCao.value.coSoLaoDongTrongPVQLs) {
          if (a.tongNuCoSo != null)
            total += a.tongNuCoSo;
        }
      }
      else if(id == 6){
        for (let a of baoCao.value.coSoLaoDongTrongPVQLs) {
          if (a.tongSoCoSoCoYeuTo != null)
            total += a.tongSoCoSoCoYeuTo;
        }
      }
      else if(id == 7){
        for (let a of baoCao.value.coSoLaoDongTrongPVQLs) {
          if (a.tongNuCoSoCoYeuTo != null)
            total += a.tongNuCoSoCoYeuTo;
        }
      }
      else if(id == 8){
        for (let a of baoCao.value.coSoLaoDongTrongPVQLs) {
          if (a.tongSoLDTiepXucTrucTiep != null)
            total += a.tongSoLDTiepXucTrucTiep;
        }
      }
      else if(id == 9){
        for (let a of baoCao.value.coSoLaoDongTrongPVQLs) {
          if (a.tongSoNuTiepXucTrucTiep != null)
            total += a.tongSoNuTiepXucTrucTiep;
        }
      }

      if(total == 0) {
        return "";
      }
      else {
        return total;
      }
    };
    const totalPLCSLD = (id) => {
      let total = 0;
      if(id == 1) {
        for (let a of baoCao.value.phanLoaiCoSoLaoDongTheoNghes) {
          if (a.soCSDuoi100 != null)
            total += a.soCSDuoi100;
        }
      }
      else if(id == 2){
        for (let a of baoCao.value.phanLoaiCoSoLaoDongTheoNghes) {
          if (a.soNLDDuoi100 != null)
            total += a.soNLDDuoi100;
        }
      }
      else if(id == 3){
        for (let a of baoCao.value.phanLoaiCoSoLaoDongTheoNghes) {
          if (a.soCSDuoi200 != null)
            total += a.soCSDuoi200;
        }
      }else if(id == 4){
        for (let a of baoCao.value.phanLoaiCoSoLaoDongTheoNghes) {
          if (a.soNLDDuoi200 != null)
            total += a.soNLDDuoi200;
        }
      }else if(id == 5){
        for (let a of baoCao.value.phanLoaiCoSoLaoDongTheoNghes) {
          if (a.soCSTren200 != null)
            total += a.soCSTren200;
        }
      }else if(id == 6){
        for (let a of baoCao.value.phanLoaiCoSoLaoDongTheoNghes) {
          if (a.soNLDTren200 != null)
            total += a.soNLDTren200;
        }
      }else if(id == 7){
        for (let a of baoCao.value.phanLoaiCoSoLaoDongTheoNghes) {
          if (a.tongSoCS != null)
            total += a.tongSoCS;
        }
      }else if(id == 8){
        for (let a of baoCao.value.phanLoaiCoSoLaoDongTheoNghes) {
          if (a.tongSoNLD != null)
            total += a.tongSoNLD;
        }
      }

      if(total == 0) {
        return "";
      }
      else {
        return total;
      }
    };
    const totalPLCSLDYTNH = (id) => {
      let total = 0;
      if(id == 1) {
        for (let a of baoCao.value.phanLoaiCoSoLaoDongNguyHais) {
          if (a.soCSDuoi100 != null)
            total += a.soCSDuoi100;
        }
      }
      else if(id == 2){
        for (let a of baoCao.value.phanLoaiCoSoLaoDongNguyHais) {
          if (a.soNLDDuoi100 != null)
            total += a.soNLDDuoi100;
        }
      }
      else if(id == 3){
        for (let a of baoCao.value.phanLoaiCoSoLaoDongNguyHais) {
          if (a.soCSDuoi200 != null)
            total += a.soCSDuoi200;
        }
      }else if(id == 4){
        for (let a of baoCao.value.phanLoaiCoSoLaoDongNguyHais) {
          if (a.soNLDDuoi200 != null)
            total += a.soNLDDuoi200;
        }
      }else if(id == 5){
        for (let a of baoCao.value.phanLoaiCoSoLaoDongNguyHais) {
          if (a.soCSTren200 != null)
            total += a.soCSTren200;
        }
      }else if(id == 6){
        for (let a of baoCao.value.phanLoaiCoSoLaoDongNguyHais) {
          if (a.soNLDTren200 != null)
            total += a.soNLDTren200;
        }
      }else if(id == 7){
        for (let a of baoCao.value.phanLoaiCoSoLaoDongNguyHais) {
          if (a.tongSoCS != null)
            total += a.tongSoCS;
        }
      }else if(id == 8){
        for (let a of baoCao.value.phanLoaiCoSoLaoDongNguyHais) {
          if (a.tongSoNLD != null)
            total += a.tongSoNLD;
        }
      }

      if(total == 0) {
        return "";
      }
      else {
        return total;
      }
    };
    const totalToChuc = (id) => {
      let total = 0;
      if(id == 1) {
        for (let a of baoCao.value.toChucBoPhanYTeTaiCSLDs) {
          if (a.tramYTe != null)
            total += a.tramYTe;
        }
      }
      else if(id == 2){
        for (let a of baoCao.value.toChucBoPhanYTeTaiCSLDs) {
          if (a.benhVien != null)
            total += a.benhVien;
        }
      }
      else if(id == 3){
        for (let a of baoCao.value.toChucBoPhanYTeTaiCSLDs) {
          if (a.phongKham != null)
            total += a.phongKham;
        }
      }
      else if(id == 4){
        for (let a of baoCao.value.toChucBoPhanYTeTaiCSLDs) {
          if (a.khac != null)
            total += a.khac;
        }
      }
      else if(id == 5){
        for (let a of baoCao.value.toChucBoPhanYTeTaiCSLDs) {
          if (a.tongSoCSYT != null)
            total += a.tongSoCSYT;
        }
      }
      else if(id == 6){
        for (let a of baoCao.value.toChucBoPhanYTeTaiCSLDs) {
          if (a.hopDongVoiCSKB != null)
            total += a.hopDongVoiCSKB;
        }
      }
      else if(id == 7){
        for (let a of baoCao.value.toChucBoPhanYTeTaiCSLDs) {
          if (a.tongCong != null)
            total += a.tongCong;
        }
      }

      if(total == 0) {
        return "";
      }
      else {
        return total;
      }
    };
    const totalCongTacYT = (id) => {
      let total = 0;
      if(id == 1) {
        for (let a of baoCao.value.trinhDoNguoiLamCongTacYTes) {
          if (a.tongSoNguoiLamCongTacYTe != null)
            total += a.tongSoNguoiLamCongTacYTe;
        }
      }
      else if(id == 2){
        for (let a of baoCao.value.trinhDoNguoiLamCongTacYTes) {
          if (a.bacSi != null)
            total += a.bacSi;
        }
      }
      else if(id == 3){
        for (let a of baoCao.value.trinhDoNguoiLamCongTacYTes) {
          if (a.bacSiYTeDuPhong != null)
            total += a.bacSiYTeDuPhong;
        }
      }
      else if(id == 4){
        for (let a of baoCao.value.trinhDoNguoiLamCongTacYTes) {
          if (a.cuNhanDieuDuong != null)
            total += a.cuNhanDieuDuong;
        }
      }
      else if(id == 5){
        for (let a of baoCao.value.trinhDoNguoiLamCongTacYTes) {
          if (a.ySy != null)
            total += a.ySy;
        }
      }
      else if(id == 6){
        for (let a of baoCao.value.trinhDoNguoiLamCongTacYTes) {
          if (a.dieuDuongTrungHoc != null)
            total += a.dieuDuongTrungHoc;
        }
      }
      else if(id == 7){
        for (let a of baoCao.value.trinhDoNguoiLamCongTacYTes) {
          if (a.hoSinhVien != null)
            total += a.hoSinhVien;
        }
      }

      if(total == 0) {
        return "";
      }
      else {
        return total;
      }
    };
    const totalSo = (id) => {
      let total = 0;
      if(id == 1) {
        for (let a of baoCao.value.lucLuongSoCuus) {
          if (a.tongSo != null)
            total += a.tongSo;
        }
      }
      else if(id == 2){
        for (let a of baoCao.value.lucLuongSoCuus) {
          if (a.nu != null)
            total += a.nu;
        }
      }

      if(total == 0) {
        return "";
      }
      else {
        return total;
      }
    };
    const totalKetQuaQuanTrac = (id) => {
      let total = 0;
      if(id == 1) {
        for (let a of baoCao.value.ketQuaQuanTracViKhiHaus) {
          if (a.tongSoNguoiLD != null)
            total += a.tongSoNguoiLD;
        }
      }
      else if(id == 2){
        for (let a of baoCao.value.ketQuaQuanTracViKhiHaus) {
          if (a.soNguoiTiepXuc != null)
            total += a.soNguoiTiepXuc;
        }
      }
      else if(id == 3){
        for (let a of baoCao.value.ketQuaQuanTracViKhiHaus) {
          if (a.nhietDo.soMauQuanTrac != null)
            total += a.nhietDo.soMauQuanTrac;
        }
      }
      else if(id == 4){
        for (let a of baoCao.value.ketQuaQuanTracViKhiHaus) {
          if (a.nhietDo.soMauKhongDat != null)
            total += a.nhietDo.soMauKhongDat;
        }
      }
      else if(id == 5){
        for (let a of baoCao.value.ketQuaQuanTracViKhiHaus) {
          if (a.doAm.soMauQuanTrac != null)
            total += a.doAm.soMauQuanTrac;
        }
      }
      else if(id == 6){
        for (let a of baoCao.value.ketQuaQuanTracViKhiHaus) {
          if (a.doAm.soMauKhongDat != null)
            total += a.doAm.soMauKhongDat;
        }
      }
      else if(id == 7){
        for (let a of baoCao.value.ketQuaQuanTracViKhiHaus) {
          if (a.tocDoGio.soMauQuanTrac != null)
            total += a.tocDoGio.soMauQuanTrac;
        }
      }
      else if(id == 8){
        for (let a of baoCao.value.ketQuaQuanTracViKhiHaus) {
          if (a.tocDoGio.soMauKhongDat != null)
            total += a.tocDoGio.soMauKhongDat;
        }
      }
      else if(id == 9){
        for (let a of baoCao.value.ketQuaQuanTracViKhiHaus) {
          if (a.anhSang.soMauQuanTrac != null)
            total += a.anhSang.soMauQuanTrac;
        }
      }
      else if(id == 10){
        for (let a of baoCao.value.ketQuaQuanTracViKhiHaus) {
          if (a.anhSang.soMauKhongDat != null)
            total += a.anhSang.soMauKhongDat;
        }
      }
      else if(id == 11){
        for (let a of baoCao.value.ketQuaQuanTracViKhiHaus) {
          if (a.on.soMauQuanTrac != null)
            total += a.on.soMauQuanTrac;
        }
      }
      else if(id == 12){
        for (let a of baoCao.value.ketQuaQuanTracViKhiHaus) {
          if (a.on.soMauKhongDat != null)
            total += a.on.soMauKhongDat;
        }
      }
      else if(id == 13){
        for (let a of baoCao.value.ketQuaQuanTracViKhiHaus) {
          if (a.rung.soMauQuanTrac != null)
            total += a.rung.soMauQuanTrac;
        }
      }
      else if(id == 14){
        for (let a of baoCao.value.ketQuaQuanTracViKhiHaus) {
          if (a.rung.soMauKhongDat != null)
            total += a.rung.soMauKhongDat;
        }
      }
      else if(id == 15){
        for (let a of baoCao.value.ketQuaQuanTracViKhiHaus) {
          if (a.hKDoc.soMauQuanTrac != null)
            total += a.hKDoc.soMauQuanTrac;
        }
      }
      else if(id == 16){
        for (let a of baoCao.value.ketQuaQuanTracViKhiHaus) {
          if (a.hKDoc.soMauKhongDat != null)
            total += a.hKDoc.soMauKhongDat;
        }
      }
      else if(id == 17){
        for (let a of baoCao.value.ketQuaQuanTracViKhiHaus) {
          if (a.phongXa.soMauQuanTrac != null)
            total += a.phongXa.soMauQuanTrac;
        }
      }
      else if(id == 18){
        for (let a of baoCao.value.ketQuaQuanTracViKhiHaus) {
          if (a.phongXa.soMauKhongDat != null)
            total += a.phongXa.soMauKhongDat;
        }
      }
      else if(id == 19){
        for (let a of baoCao.value.ketQuaQuanTracViKhiHaus) {
          if (a.dienTuTruong.soMauQuanTrac != null)
            total += a.dienTuTruong.soMauQuanTrac;
        }
      }
      else if(id == 20){
        for (let a of baoCao.value.ketQuaQuanTracViKhiHaus) {
          if (a.dienTuTruong.soMauKhongDat != null)
            total += a.dienTuTruong.soMauKhongDat;
        }
      }
      else if(id == 21){
        for (let a of baoCao.value.ketQuaQuanTracViKhiHaus) {
          if (a.yeuToKhac.soMauQuanTrac != null)
            total += a.yeuToKhac.soMauQuanTrac;
        }
      }
      else if(id == 22){
        for (let a of baoCao.value.ketQuaQuanTracViKhiHaus) {
          if (a.yeuToKhac.soMauKhongDat != null)
            total += a.yeuToKhac.soMauKhongDat;
        }
      }

      if(total == 0) {
        return "";
      }
      else {
        return total;
      }
    };
    const totalKetQuaBui = (id) => {
      let total = 0;
      if(id == 1) {
        for (let a of baoCao.value.ketQuaQuanTracYeuToBuis) {
          if (a.tongSoNguoiLD != null)
            total += a.tongSoNguoiLD;
        }
      }
      else if(id == 2){
        for (let a of baoCao.value.ketQuaQuanTracYeuToBuis) {
          if (a.soNguoiTiepXuc != null)
            total += a.soNguoiTiepXuc;
        }
      }
      else if(id == 3){
        for (let a of baoCao.value.ketQuaQuanTracYeuToBuis) {
          if (a.buiToanPhan.soMauQuanTrac != null)
            total += a.buiToanPhan.soMauQuanTrac;
        }
      }
      else if(id == 4){
        for (let a of baoCao.value.ketQuaQuanTracYeuToBuis) {
          if (a.buiToanPhan.soMauKhongDat != null)
            total += a.buiToanPhan.soMauKhongDat;
        }
      }
      else if(id == 5){
        for (let a of baoCao.value.ketQuaQuanTracYeuToBuis) {
          if (a.buiHoHap.soMauQuanTrac != null)
            total += a.buiHoHap.soMauQuanTrac;
        }
      }
      else if(id == 6){
        for (let a of baoCao.value.ketQuaQuanTracYeuToBuis) {
          if (a.buiHoHap.soMauKhongDat != null)
            total += a.buiHoHap.soMauKhongDat;
        }
      }
      else if(id == 7){
        for (let a of baoCao.value.ketQuaQuanTracYeuToBuis) {
          if (a.buiSilic.soMauQuanTrac != null)
            total += a.buiSilic.soMauQuanTrac;
        }
      }
      else if(id == 8){
        for (let a of baoCao.value.ketQuaQuanTracYeuToBuis) {
          if (a.buiSilic.soMauKhongDat != null)
            total += a.buiSilic.soMauKhongDat;
        }
      }
      else if(id == 9){
        for (let a of baoCao.value.ketQuaQuanTracYeuToBuis) {
          if (a.buiKhac.soMauQuanTrac != null)
            total += a.buiKhac.soMauQuanTrac;
        }
      }
      else if(id == 10){
        for (let a of baoCao.value.ketQuaQuanTracYeuToBuis) {
          if (a.buiKhac.soMauKhongDat != null)
            total += a.buiKhac.soMauKhongDat;
        }
      }
      else if(id == 11){
        for (let a of baoCao.value.ketQuaQuanTracYeuToBuis) {
          if (a.tongSo.soMauQuanTrac != null)
            total += a.tongSo.soMauQuanTrac;
        }
      }
      else if(id == 12){
        for (let a of baoCao.value.ketQuaQuanTracYeuToBuis) {
          if (a.tongSo.soMauKhongDat != null)
            total += a.tongSo.soMauKhongDat;
        }
      }

      if(total == 0) {
        return "";
      }
      else {
        return total;
      }
    };
    const addKetQua = () => {
        baoCao.value.ketQuaQuanTracViKhiHaus.push({tenCoSo: "", nhietDo: {},doAm: {},tocDoGio: {},anhSang: {},on: {},rung: {},hKDoc: {},phongXa: {},dienTuTruong: {},yeuToKhac: {},});
    }
    const addKetQuaBui = () => {
        baoCao.value.ketQuaQuanTracYeuToBuis.push({tenCoSo: "", buiToanPhan: {},buiHoHap: {},buiSilic: {},buiKhac: {},tongSo: {}});
    }
    const addTinhHinhSucKhoe = () => {
      baoCao.value.tinhHinhSucKhoes.push({tenCoSo: "", om: {},taiNanLaoDong: {},benhNgheNghiep: {},tongSo: {}});
    }
    const addNhomBenh = () => {
      baoCao.value.soCoSoBaoCaos.push({nhomBenh: "", sauThangDauNam: {}, sauThangCuoiNam: {}});
    }
    const addDanhSachBenh= () => {
      baoCao.value.danhSachMacBNNs.push({hoTenBenhNhan: "",});
    }
    const addDanhGia = () => {
      baoCao.value.danhGiaCacYeuTos.push({tenCoSo: "",});
    }
    const totalTinhHinhSucKhoe = (id) => {
      let total = 0;
      if(id == 1) {
        for (let a of baoCao.value.tinhHinhSucKhoes) {
          if (a.om.soNguoi != null)
            total += a.om.soNguoi;
        }
      }
      else if(id == 2){
        for (let a of baoCao.value.tinhHinhSucKhoes) {
          if (a.om.tongSoNgay != null)
            total += a.om.tongSoNgay;
        }
      }
      else if(id == 3){
        for (let a of baoCao.value.tinhHinhSucKhoes) {
          if (a.taiNanLaoDong.soNguoi != null)
            total += a.taiNanLaoDong.soNguoi;
        }
      }
      else if(id == 4){
        for (let a of baoCao.value.tinhHinhSucKhoes) {
          if (a.taiNanLaoDong.tongSoNgay != null)
            total += a.taiNanLaoDong.tongSoNgay;
        }
      }
      else if(id == 5){
        for (let a of baoCao.value.tinhHinhSucKhoes) {
          if (a.benhNgheNghiep.soNguoi != null)
            total += a.benhNgheNghiep.soNguoi;
        }
      }
      else if(id == 6){
        for (let a of baoCao.value.tinhHinhSucKhoes) {
          if (a.benhNgheNghiep.tongSoNgay != null)
            total += a.benhNgheNghiep.tongSoNgay;
        }
      }
      else if(id == 7){
        for (let a of baoCao.value.tinhHinhSucKhoes) {
          if (a.tongSo.soNguoi != null)
            total += a.tongSo.soNguoi;
        }
      }
      else if(id == 8){
        for (let a of baoCao.value.tinhHinhSucKhoes) {
          if (a.tongSo.tongSoNgay != null)
            total += a.tongSo.tongSoNgay;
        }
      }

      if(total == 0) {
        return "";
      }
      else {
        return total;
      }
    };
    const totalNhomBenh = (id) => {
      let total = 0;
      if(id == 1) {
        for (let a of baoCao.value.soCoSoBaoCaos) {
          if (a.sauThangDauNam.tongSo != null)
            total += a.sauThangDauNam.tongSo;
        }
      }
      else if(id == 2){
        for (let a of baoCao.value.soCoSoBaoCaos) {
          if (a.sauThangCuoiNam.tongSo != null)
            total += a.sauThangCuoiNam.tongSo;
        }
      }

      if(total == 0) {
        return "";
      }
      else {
        return total;
      }
    };
    const totalBenhNgheNghiep = (id) => {
      let total = 0;
      if(id == 1) {
        for (let a of baoCao.value.truongHopMacBenhNgheNghiep) {
          if (a.sauThangDauNam.tongSo != null)
            total += a.sauThangDauNam.tongSo;
        }
      }
      else if(id == 2){
        for (let a of baoCao.value.truongHopMacBenhNgheNghiep) {
          if (a.sauThangCuoiNam.tongSo != null)
            total += a.sauThangCuoiNam.tongSo;
        }
      }

      if(total == 0) {
        return "";
      }
      else {
        return total;
      }
    };
    const totalTaiNanLaoDong = (id) => {
      let total = 0;
      if(id == 1) {
        for (let a of baoCao.value.truongTaiNanLaoDong) {
          if (a.sauThangDauNam.mac != null)
            total += a.sauThangDauNam.mac;
        }
      }
      else if(id == 2){
        for (let a of baoCao.value.truongTaiNanLaoDong) {
          if (a.sauThangDauNam.chet != null)
            total += a.sauThangDauNam.chet;
        }
      }
      else if(id == 3){
        for (let a of baoCao.value.truongTaiNanLaoDong) {
          if (a.sauThangCuoiNam.mac != null)
            total += a.sauThangCuoiNam.mac;
        }
      }else if(id == 4){
        for (let a of baoCao.value.truongTaiNanLaoDong) {
          if (a.sauThangCuoiNam.chet != null)
            total += a.sauThangCuoiNam.chet;
        }
      }

      if(total == 0) {
        return "";
      }
      else {
        return total;
      }
    };
    const totalDanhGiaCacYeuTo = (id) => {
      let total = 0;
      if(id == 1) {
        for (let a of baoCao.value.danhGiaCacYeuTos) {
          if (a.tongSoNguoiLD != null)
            total += a.tongSoNguoiLD;
        }
      }
      else if(id == 2){
        for (let a of baoCao.value.danhGiaCacYeuTos) {
          if (a.yeuToTiepXuc != null && a.yeuToTiepXuc != "")
            total += 1;
        }
      }
      else if(id == 3){
      for (let a of baoCao.value.danhGiaCacYeuTos) {
        if (a.soNguoiTiepXuc != null)
          total += a.soNguoiTiepXuc;
      }
    }
     else if(id == 4){
      for (let a of baoCao.value.danhGiaCacYeuTos) {
        if (a.ketQuaDanhGia != null&& a.ketQuaDanhGia != "")
          total += 1;
      }
    }
     else if(id == 5){
      for (let a of baoCao.value.danhGiaCacYeuTos) {
        if (a.soNguoiDuocDanhGia != null)
          total += a.soNguoiDuocDanhGia;
      }
    }
     else if(id == 6){
      for (let a of baoCao.value.danhGiaCacYeuTos) {
        if (a.ketQuaDanhGiaTamSinhLy != null && a.ketQuaDanhGia != "")
          total += 1;
      }
    }

      if(total == 0) {
        return "";
      }
      else {
        return total;
      }
    };
    const totalPhatHienBenh = (id) => {
      let total = 0;
      if(id == 1) {
        for (let a of baoCao.value.ketQuaKhamPhatHienBenhs) {
          if (a.phatBenhKhiKham.tongSo != null)
            total += a.phatBenhKhiKham.tongSo;
        }
      }
      else if(id == 2){
        for (let a of baoCao.value.ketQuaKhamPhatHienBenhs) {
          if (a.phatBenhKhiKham.nu != null)
            total += a.phatBenhKhiKham.nu;
        }
      }
      else if(id == 3) {
        for (let a of baoCao.value.ketQuaKhamPhatHienBenhs) {
          if (a.duocChanDoanBenh.tongSo != null)
            total += a.duocChanDoanBenh.tongSo;
        }
      }
      else if(id == 4){
        for (let a of baoCao.value.ketQuaKhamPhatHienBenhs) {
          if (a.duocChanDoanBenh.nu != null)
            total += a.duocChanDoanBenh.nu;
        }
      }
      else if(id == 5) {
        for (let a of baoCao.value.ketQuaKhamPhatHienBenhs) {
          if (a.duocGiamDinh.tongSo != null)
            total += a.duocGiamDinh.tongSo;
        }
      }
      else if(id == 6){
        for (let a of baoCao.value.ketQuaKhamPhatHienBenhs) {
          if (a.duocGiamDinh.nu != null)
            total += a.duocGiamDinh.nu;
        }
      }
      else if(id == 7) {
        for (let a of baoCao.value.ketQuaKhamPhatHienBenhs) {
          if (a.ketQuaDuoi5.tongSo != null)
            total += a.ketQuaDuoi5.tongSo;
        }
      }
      else if(id == 8){
        for (let a of baoCao.value.ketQuaKhamPhatHienBenhs) {
          if (a.ketQuaDuoi5.nu != null)
            total += a.ketQuaDuoi5.nu;
        }
      }
      else if(id == 9) {
        for (let a of baoCao.value.ketQuaKhamPhatHienBenhs) {
          if (a.ketQuaTu5Den30.tongSo != null)
            total += a.ketQuaTu5Den30.tongSo;
        }
      }
      else if(id == 10){
        for (let a of baoCao.value.ketQuaKhamPhatHienBenhs) {
          if (a.ketQuaTu5Den30.nu != null)
            total += a.ketQuaTu5Den30.nu;
        }
      }
      else if(id == 11) {
        for (let a of baoCao.value.ketQuaKhamPhatHienBenhs) {
          if (a.ketQuaTren31.tongSo != null)
            total += a.ketQuaTren31.tongSo;
        }
      }
      else if(id == 12){
        for (let a of baoCao.value.ketQuaKhamPhatHienBenhs) {
          if (a.ketQuaTren31.nu != null)
            total += a.ketQuaTren31.nu;
        }
      }

      if(total == 0) {
        return "";
      }
      else {
        return total;
      }
    };
    const totalMacBenhNN = (id) => {
      let total = 0;
      if(id == 1) {
        for (let a of baoCao.value.danhSachMacBNNs) {
        if (a.tuoiNam != null && a.tuoiNam > 0)
            total += 1;
        }
      }
      else if(id == 2){
        for (let a of baoCao.value.danhSachMacBNNs) {
          if (a.tuoiNu != null && a.tuoiNu > 0)
            total += 1;
        }
      }
      else if(id == 3){
        for (let a of baoCao.value.danhSachMacBNNs) {
          if (a.ngheKhiBNN != null && a.ngheKhiBNN != "")
            total += 1;
        }
      }
      else if(id == 4){
        for (let a of baoCao.value.danhSachMacBNNs) {
          if (a.tuoiNghe != null && a.tuoiNghe > 0)
            total += 1;
        }
      }
      else if(id == 5){
        for (let a of baoCao.value.danhSachMacBNNs) {
          if (a.tenBNN != null && a.tenBNN != "")
            total += 1;
        }
      }
      else if(id == 6){
        for (let a of baoCao.value.danhSachMacBNNs) {
          if (a.tyLeSuyGiam != null && a.tyLeSuyGiam > 0)
            total += 1;
        }
      }
      else if(id == 7){
        for (let a of baoCao.value.danhSachMacBNNs) {
          if (a.congViecHienNay != null && a.congViecHienNay !="")
            total += 1;
        }
      }

      if(total == 0) {
        return "";
      }
      else {
        return total;
      }
    };

    const addReport = () => {
      if(baoCao.value.thoiGianBC == null)
      {
        toast.add({
          severity: 'error',
          summary: 'Lỗi',
          detail:'Vui lòng chọn thời gian báo cáo',
          life: 2000
        });
      }
      else {
        CDCRepository.createBaoCaoYTeLaoDongTuyenHuyen(baoCao.value)
            .then((response) => {
              const temp = ref({} as BaoCaoYTeLaoDongTuyenHuyen);
              baoCao.value = temp.value;
              initDb();
              toast.add({
                severity: 'success',
                summary: 'Thêm báo cáo',
                detail: 'Thêm báo cáo thành công vào hệ thống',
                life: 2000
              });
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail: err.response.data,
                life: 2000
              });
            });
      }
    }

    return {
      date,
      service,
      addReport,
      baoCao,
      totalCSLD,
      totalPLCSLD,
      totalPLCSLDYTNH,
      totalToChuc,
      totalCongTacYT,
      totalSo,
      totalKetQuaQuanTrac,
      addKetQua,
      addKetQuaBui,
      totalKetQuaBui,
      addTinhHinhSucKhoe,
      totalTinhHinhSucKhoe,
      totalNhomBenh,
      addNhomBenh,
      totalBenhNgheNghiep,
      totalTaiNanLaoDong,
      totalPhatHienBenh,
      totalDanhGiaCacYeuTo,
      addDanhGia,
      totalMacBenhNN,
      addDanhSachBenh
      // addHoSo
    }
  }

}
